<template>
  <div>
    <a-modal
      v-model:visible="addonBeforeVisible"
      title="Collection 列表"
      style="width: 800px;"
    >
      <a-form
        ref="formRef"
        :model="formState"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-bottom: 16px;"
      >
        <a-row :gutter="[16]">
          <a-col :span="12">
            <a-form-item label="Collection ID" name="colId">
              <a-input
                v-model:value="formState.colId"
                allow-clear
                placeholder="请输入"
                :maxlength="10"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Collection名称" name="name">
              <a-input
                v-model:value="formState.name"
                allow-clear
                placeholder="请输入"
                :maxlength="255"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="12" style="text-align: right;">
            <a-space>
              <a-button @click="handleReset">重置</a-button>
              <a-button type="primary" @click="handleQuery">查询</a-button>
            </a-space>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        class="mb10"
        :scroll="{ y: 400 }"
        :dataSource="colList"
        :columns="columns"
        :pagination="false"
      >
        <template #deal="{ text }">
          <a-button type="link" @click="() => addonBeforeChange(false, text)"
            >操作</a-button
          >
        </template>
      </a-table>
      <div v-if="colList && colList.length > 0" class="mb30">
        <div
          style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
        >
          <a-pagination
            v-if="addonPagination.pageSize"
            class="mr20"
            v-model:current="addonPagination.pageNum"
            :total="addonPagination.total"
            v-model:pageSize="addonPagination.pageSize"
            :show-total="total => `共 ${total} 条数据`"
            :showSizeChanger="false"
            @change="getColList"
          />
          <a-select
            class="mr10"
            style="min-width: 80px;"
            v-model:value="addonPagination.pageSize"
            @change="getColList"
            placeholder="条"
            :options="[
              { value: 10, label: 10 },
              { value: 20, label: 20 },
              { value: 30, label: 30 },
              { value: 40, label: 40 },
              { value: 50, label: 50 }
            ]"
          >
          </a-select>
          <div class="lh30 mr10">条/页</div>
        </div>
      </div>
      <template #footer></template>
    </a-modal>
  </div>
</template>
<script>
import { toRefs, inject, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      pageNo: 1,
      columns: [
        {
          title: '操作',
          slots: { customRender: 'deal' }
        },
        {
          title: 'ID',
          dataIndex: 'colId',
          key: 'colId'
        },
        {
          title: 'Collection名称',
          dataIndex: 'name',
          key: 'name'
        }
      ],
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 16
      }
    })
    return {
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
}
</script>
